module.exports = __webpack_public_path__ + "img/defense-2015-doctor.922105c2.jpg";